// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  TtwPitchVideoKindV1,
  TtwVideoProviderV1,
  TtwPageStageV1,
  AdminTtwHighlight,
  AdminTtwKeyStat,
} from "./types";

export default {
  id: __t.uuid(),
  targetProperty: __t.option(__t.uuid()),
  featureImage: __t.string(),
  get pitchVideoKind() {
    return TtwPitchVideoKindV1;
  },
  pitchVideoValue: __t.option(__t.string()),
  get pitchVideoProvider() {
    return __t.option(TtwVideoProviderV1);
  },
  businessName: __t.string(),
  category: __t.string(),
  showNominator: __t.bool(),
  showTotalReserved: __t.bool(),
  showAppreciationShare: __t.bool(),
  get highlights() {
    return __t.array(AdminTtwHighlight);
  },
  stewardImage: __t.option(__t.string()),
  stewardQuote: __t.option(__t.string()),
  stewardAttribution: __t.option(__t.string()),
  stewardAbout: __t.option(__t.string()),
  get keyStats() {
    return __t.array(AdminTtwKeyStat);
  },
  realEstateAbout: __t.option(__t.string()),
  targetArea: __t.option(__t.string()),
  gallery: __t.array(__t.string()),
  propertyType: __t.option(__t.string()),
  stories: __t.option(__t.string()),
  yearBuilt: __t.option(__t.string()),
  propertySqft: __t.option(__t.i32()),
  showEstimatedValueChart: __t.bool(),
  sharePriceCents: __t.i64(),
  totalShares: __t.i64(),
  targetReturnBps: __t.i32(),
  targetReturnBpsMax: __t.i32(),
  targetRaiseCents: __t.i64(),
  get stage() {
    return TtwPageStageV1;
  },
  appreciationShareBps: __t.i32(),
};
